"use client";
import { hasData } from "@/lib/helpers";
import Section from "../components/Section";
import CategoryCard from "@/components/CategoryCard";

type CustomizedConsultingIndustryProps = {
  sectionInfo: PageSections;
  data?: {
    heading?: string;
    cards?: {
      label: string;
      icon?: string;
    }[];
  };
};

export default function CustomizedConsultingIndustry({
  data,
  sectionInfo,
}: CustomizedConsultingIndustryProps) {
  if (!hasData(data)) return null;

  return (
    <Section
      className={`${sectionInfo.sectionClass} Customized Consulting for Your Industry`}
      id={sectionInfo.sectionId}
      title={data?.heading}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 auto-rows-auto gap-5 !text-center items-center">
        {data?.cards?.map((card, index) => (
          <CategoryCard
            key={`customized-consulting-for-your-industry-${index}`}
            title={card?.label}
            icon={card?.icon}
            isContentType
            className="!text-black !bg-indigo-50 !p-3"
          />
        ))}
      </div>
    </Section>
  );
}
